
import { macroCondition, getGlobalConfig } from '@embroider/macros';


import defineModule0 from "./-embroider-implicit-modules.js";

import * as amdModule0 from "./config/environment.ts"
import * as amdModule1 from "./deprecation-workflow.ts"
import * as amdModule2 from "./router.ts"
import * as amdModule3 from "./services/page-title.js"
import * as amdModule4 from "./services/intl.js"
import * as amdModule5 from "./templates/application.gts"
import * as amdModule6 from "./routes/application.ts"
import * as amdModule7 from "./templates/contact.gts"
import * as amdModule8 from "./templates/experience.gts"
import * as amdModule9 from "./templates/index.gts"
import * as amdModule10 from "./templates/not-found.gts"
import * as amdModule11 from "./templates/privacy.gts"
import * as amdModule12 from "./templates/publications.gts"
import * as amdModule13 from "./templates/services.gts"

let exportFastbootModules = {};





export default Object.assign(
  {},
defineModule0,
  {
"devloed-website/config/environment": amdModule0,
"devloed-website/deprecation-workflow": amdModule1,
"devloed-website/router": amdModule2,
"devloed-website/services/page-title": amdModule3,
"devloed-website/services/intl": amdModule4,
"devloed-website/templates/application": amdModule5,
"devloed-website/routes/application": amdModule6,
"devloed-website/templates/contact": amdModule7,
"devloed-website/templates/experience": amdModule8,
"devloed-website/templates/index": amdModule9,
"devloed-website/templates/not-found": amdModule10,
"devloed-website/templates/privacy": amdModule11,
"devloed-website/templates/publications": amdModule12,
"devloed-website/templates/services": amdModule13,
  },
  exportFastbootModules
);
